<template>
  <div class="safe_place_button_block col-lg-6 col-md-8 col-12">
    <div class="row">
      <div class="col-12">
        <label for="" class="col-form-label text-center">
          {{ $helper.trans('Provide_a_safe_place_to_leave_parcel') }}: *
        </label>
        <textarea v-model="form.remarks" cols="50" rows="10"></textarea>
        <span v-if="errors.remarks" class="error-message">{{ errors.remarks[0] }}</span>
        <div v-if="$helper.trans('Safe_place_bottom_message') !== '--'" class="text-danger text-center mt-4">{{ $helper.trans('Safe_place_bottom_message') }}</div>

        <div class="text-center mt-2">
          <button type="button" class="btn btn-yellow" @click="saveData">{{ $helper.trans('Save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      form: {
        remarks: '',
      },
      datepickerCustomSettings: {
        minDate: '',
        noWeekends: true,
      },
    }
  },
  props: {
    errors: {
      type: Object,
      required: false,
      default: {},
    },
  },
  methods: {
    saveData() {
      const data = {
        opened_box: 4,
        ...this.form,
      }

      this.$emit('save', data)
    },
  }
}
</script>
